import { useState, useMemo } from 'react'
import { useDebouncedEffect } from './useDebounce'

const WAIT_MS = 3000

export default function useEmail() {
  const [emailParts, setEmailParts] = useState(['', ''])

  const [active, email] = useMemo(() => {
    const active = emailParts.join('') !== ''
    return [active, active ? `${emailParts[0]}@${emailParts[1]}` : '']
  }, [emailParts])

  useDebouncedEffect(
    () => {
      setEmailParts(['hello', 'gigmade.com'])
    },
    WAIT_MS,
    []
  )

  return { active, email, emailParts }
}
